/**
 * 验证方法
 */
const regPhone = /^1[23456789]\d{9}$/
const regEmail = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-z0-9]+([-a-z0-9]*[a-z0-9])?\.){1,63}[a-z0-9]+$/

/**
 * function: 检测是否为空
 * @param {string}    value     被验证的值
 * @param {string}    tag       被验证的类型，用于前端展示输出
 * @return {Object}             验证结果 {valid: Boolean, message: String}
 */
function trim (value, tag) {
  if (value.replace(/(^\s*)|(\s*$)/g, '')) {
    return {
      valid: true,
      message: '不为空'
    }
  } else {
    return {
      valid: false,
      message: tag || '此处不能为空'
    }
  }
}

/**
 * 公共验证方法
 * @param  {Any}      value     被验证的值
 * @param  {RegExp}   reg       验证正则
 * @param  {String}   message   提示文案
 * @return {Object}             验证结果 {valid: Boolean, message: String}
 */
function testValue (value, reg, message) {
  return {
    valid: reg.test(value),
    message
  }
}

export default {
  /**
   * 验证字符串是否为空
   * @param {String}  value  被验证的值
   * @param {String}  tag    [可选]类型
   */
  checkIsEmpty (value = '', tag) {
    return trim(value, tag)
  },
  /**
   * 验证字符串是否为手机
   * @param {String}  value  被验证的值
   * @param {String}  tag    [可选]被验证的类型，用于前端展示输出
   * @param {String}  msg    [可选]提示文案
   */
  checkPhone (value, tag, msg) {
    let trimStr = trim(value, tag)
    if (!trimStr.valid) return trimStr
    return testValue(value, regPhone, msg || '手机号格式有误')
  },
  /**
   * 验证字符串是否为邮箱
   * @param {String}  value  被验证的值
   * @param {String}  tag    [可选]被验证的类型，用于前端展示输出
   * @param {String}  msg    [可选]提示文案
   */
  checkMail (value, tag, msg) {
    let trimStr = trim(value, tag)
    if (!trimStr.valid) return trimStr
    return testValue(value, regEmail, msg || '邮箱格式有误')
  },
  /**
   * 验证字符串最大长度
   * @param {String}  value  被验证的值
   * @param {String}  tag    [可选]被验证的类型，用于前端展示输出
   * @param {String}  msg    [可选]提示文案
   */
  checkMaxLength (value, tag, msg) {
    return testValue(value, /^.{0,60}$/, msg || '长度不能超过60个字符')
  }
}
